import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const SettingsCtx = createContext({ settings: { sla_enabled: true }, reload: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({ sla_enabled: true, auto_assign_mode: "off", agent_pool: [] });

  const reload = async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
    } catch { /* not logged in */ }
  };

  useEffect(() => {
    if (localStorage.getItem("hd_token")) reload();
    const handler = () => { if (localStorage.getItem("hd_token")) reload(); };
    window.addEventListener("hd:settings-changed", handler);
    window.addEventListener("hd:login", handler);
    return () => {
      window.removeEventListener("hd:settings-changed", handler);
      window.removeEventListener("hd:login", handler);
    };
  }, []);

  return <SettingsCtx.Provider value={{ settings, reload }}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
